module.exports = __webpack_public_path__ + "img/main_logo.0431b2cd.svg";